import { TRACE_ADDIN_DEBUG_AUTH } from "../taskpane.constants";

export function logAuthDebug(message: string, extra?: Record<string, unknown>): void {
  if (!TRACE_ADDIN_DEBUG_AUTH || typeof console === "undefined") {
    return;
  }
  console.log("[trace-excel-addin auth]", message, extra ?? "");
}
